module.exports = __webpack_public_path__ + "static/image/together/pc/visual@3x.ver2_0_2.jpg?59bd60cb";